import classnames from 'classnames';
import React__default from 'react';
import '../visually_hidden/index.js';
import { countBadge, kind, size, disabled } from './count_badge.css.js';
import { VisuallyHidden } from '../visually_hidden/visually_hidden.js';

/**
 * A badge that shows a count, e.g. a step number or count of items.
 */
const CountBadge = ({ value, kind: kind$1 = 'neutral', size: size$1 = 'xsmall', disabled: disabled$1 = false, className, ...rest }) => {
    return (React__default.createElement("span", { ...rest, className: classnames(countBadge, kind[kind$1], size[size$1], { [disabled]: disabled$1 }, className) },
        React__default.createElement(VisuallyHidden, null, "("),
        value,
        React__default.createElement(VisuallyHidden, null, ")")));
};

export { CountBadge };
